import { FC, useId } from 'react';
import { DropDownProps, Options } from './Select.types';
import { RadioButton } from 'primereact/radiobutton';

export const DropdownItem: FC<DropDownProps> = ({
  option,
  selectedOption,
  onOptionChange,
}) => {
  const id = useId();

  return (
    <div
      className="flex items-center pl-4 pt-3 rounded-md cursor-pointer"
      onClick={() => onOptionChange(option)}
    >
      <RadioButton
        unstyled
        inputId={id}
        name="option"
        value={option}
        onChange={() => onOptionChange(option)}
        checked={selectedOption?._id === option?._id}
        className="hidden"
      />
      <div
        className={`flex items-center justify-center w-[18px] h-[18px] cursor-pointer ${
          selectedOption?._id === option?._id
            ? 'border-[0.75px] border-primary bg-white'
            : 'border-[2.75px] border-[#939393]'
        } rounded-full mr-3`}
      >
        {selectedOption?._id === option?._id ? (
          <div className="w-2.5 h-2.5 bg-primary rounded-full"></div>
        ) : (
          <div className="w-2.5 h-2.5 bg-transparent rounded-full"></div>
        )}
      </div>
      <label htmlFor={id} className="text-white">
        {option?.name}
      </label>
    </div>
  );
};

export const ValueTemplate: React.FC<{
  selectedOption: Options | null;
  placeholder: string;
}> = ({ selectedOption, placeholder }) => {
  return (
    <div className="flex items-center gap-2 pl-[3px]  rounded-md text-[13.8px] font-raleway text-white">
      <div>
        {selectedOption ? (
          selectedOption?.name
        ) : (
          <span className="text-[#939393] font-raleway">{placeholder}</span>
        )}
      </div>
    </div>
  );
};
